import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/axios/requestInfo";
import { api } from "../../../resources/api";
import { IPaymentItem } from "../../payment/bitrixPayment";
import { cleanPhone } from "../../../utils/form/phoneFormat";

import {ICard} from "./types";

export const fetchGetCards = createAsyncThunk<ICard[]>(
  "getCards/fetchGetCards",
  async () => {
    try {
      const response = await axiosInstance.get(api.profile.cards.GET_CARD);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }
);

export const fetchDelCards = createAsyncThunk<ICard[], number>(
    "delCards/fetchDelCards",
    async (cardId) => {
        try {
            const response = await axiosInstance.delete(`${api.profile.cards.DELETE_CARD}${cardId}`);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }
);

export const fetchSaveCard = createAsyncThunk<ICard, { yookassaId: string; cardData?: any }>(
    "saveCard/fetchSaveCard",
    async ({ yookassaId, cardData }) => {
        try {
            const first6 = cardData?.card?.first6 || "";
            const last4 = cardData?.card?.last4 || "";
            const cardNumber = first6 && last4 
                ? `${first6}000000${last4}` 
                : "0000000000000000";
            
            let expiryMonth: number;
            const rawMonth = cardData?.card?.expiry_month;
            if (typeof rawMonth === 'string') {
                expiryMonth = parseInt(rawMonth, 10);
                if (isNaN(expiryMonth)) {
                    expiryMonth = 12;
                }
            } else if (typeof rawMonth === 'number') {
                expiryMonth = rawMonth;
            } else {
                expiryMonth = 12;
            }
            
            let expiryYear: number;
            const rawYear = cardData?.card?.expiry_year;
            if (typeof rawYear === 'string') {
                expiryYear = parseInt(rawYear, 10);
                if (isNaN(expiryYear)) {
                    expiryYear = new Date().getFullYear() + 1;
                }
            } else if (typeof rawYear === 'number') {
                expiryYear = rawYear;
            } else {
                expiryYear = new Date().getFullYear() + 1;
            }
            
            const cardHolder = cardData?.card?.card_type || cardData?.card?.card_type_name || "CARD";

            const cardPayload = {
                card_number: cardNumber,
                card_holder: cardHolder,
                expiry_month: expiryMonth,
                expiry_year: expiryYear,
                yookassa_id: yookassaId,
                is_default: false,
            };

            const response = await axiosInstance.post(api.profile.cards.ADD_CARD, cardPayload);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }
);

// fetchAddCardToken удалён вместе с ЮKassa: привязка карты делалась через её
// платёж на 11 ₽ с последующим возвратом. У Т-Кассы механизм другой
// (AddCard/AttachCard + Rebill) и пока не реализован.
